import React, { useEffect, useState } from "react";
import axios, { MEDIA_BASE_URL } from "../../axios/axios";
import { Link } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import stripHtml from "../../utils/stripHtml";

const BlogPages = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 5;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("/blog");
        setBlogs(response.data.blogs);
      } catch (error) {
        console.error("Failed to fetch blogs:", error);
      }
    };

    fetchBlogs();
  }, []);

  // Pagination logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container py-5">
        {/* Header Section */}
        <div className="text-center mb-5">
          <h1 className="display-6 mb-3 fw-bold" style={{ color: "#2c3e50" }}>
            Our Blogs
          </h1>
          <p className="lead text-muted mb-4">
            Discover tips, techniques, and inspiration for capturing life's most
            precious moments.
          </p>
        </div>

        {/* Blog Cards */}
        <div className="row">
          {currentBlogs.map((blog) => (
            <div key={blog.id} className="col-md-6 col-lg-4 mb-4">
              <div
                className="card h-100 shadow-sm border-0"
                style={{ borderRadius: "15px", overflow: "hidden" }}
              >
                <div className="position-relative">
                  <img
                    src={`${MEDIA_BASE_URL}/${blog.image}`}
                    crossOrigin="anonymous"
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                    alt={blog.title}
                  />
                  <span
                    className="badge position-absolute top-0 end-0 m-2 px-3 py-1"
                    style={{
                      backgroundColor: "#20B2AA",
                      borderRadius: "20px",
                      fontSize: "0.8rem",
                    }}
                  >
                    {blog.service}
                  </span>
                </div>

                <div className="card-body d-flex flex-column">
                  <h5 className="card-title mb-2" style={{ color: "#2c3e50" }}>
                    {blog.title}
                  </h5>
                  <p className="card-text text-muted mb-3 flex-grow-1">
                    {(() => {
                      const plainText = stripHtml(blog.description);
                      return plainText.length > 100
                        ? plainText.substring(0, 100) + "..."
                        : plainText;
                    })()}
                  </p>

                  <div className="d-flex justify-content-between align-items-center">
                    <Link to={`/blog/${blog.id}`}>
                      <button
                        className="btn btn-sm rounded-pill px-3"
                        style={{
                          backgroundColor: "#20B2AA",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Read More
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="clearfix">
          <div className="hint-text">
            Showing <b>{Math.min(indexOfLastBlog, blogs.length)}</b> out of{" "}
            <b>{blogs.length}</b> entries
          </div>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <a
                href="##"
                className="page-link shadow-none"
                onClick={() => paginate(currentPage - 1)}
              >
                Previous
              </a>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li
                key={i + 1}
                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
              >
                <a
                  href="##"
                  className="page-link shadow-none"
                  onClick={() => paginate(i + 1)}
                >
                  {i + 1}
                </a>
              </li>
            ))}

            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <a
                href="##"
                className="page-link shadow-none"
                onClick={() => paginate(currentPage + 1)}
              >
                Next
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPages;
